import React from "react"
import { Tag as TagOg } from "@mallardbay/lib-react-components"
import type { TagProps } from "@mallardbay/lib-react-components"

export default function Tag(props: TagProps) {
    return <TagOg {...props} />
}
